// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Users_pagination__X1fNJ"};